import { render, staticRenderFns } from "./AnnouncementModal.vue?vue&type=template&id=4675c749&"
import script from "./AnnouncementModal.vue?vue&type=script&lang=js&"
export * from "./AnnouncementModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports